

import React, { useContext, useEffect, useState } from 'react';
import './RelatedProducts.css';
import Item from '../Item/Item';
import { ShopContext } from '../../Context/ShopContext'; // ✅ Fixed import path

const RelatedProducts = (props) => {
    const { all_product } = useContext(ShopContext);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    // Determine current category/subcategory to use for filtering
    let currentProductCategory = props.category || '';
    if (!currentProductCategory && props.productId && all_product && all_product.length > 0) {
        const prod = all_product.find(p => p.id === props.productId);
        if (prod) {
            currentProductCategory = prod.subcategory || prod.type || prod.category || '';
        }
    }
    currentProductCategory = currentProductCategory ? currentProductCategory.toString().toLowerCase() : 'women';

    useEffect(() => {
        if (all_product && all_product.length > 0) {
            
            // Filter products by the same subcategory/type/category or name, excluding the current product if ID is provided
            const filteredProducts = all_product.filter(item => {
                const itemSub = (item.subcategory || item.type || '').toString().toLowerCase();
                const itemCategory = (item.category || '').toString().toLowerCase();
                const inName = item.name && item.name.toLowerCase().includes(currentProductCategory);
                const isSameCategory = itemSub === currentProductCategory || itemCategory.includes(currentProductCategory) || inName;
                const isNotCurrentProduct = props.productId ? item.id !== props.productId : true;
                return isSameCategory && isNotCurrentProduct;
            });
            
            
            // Get random 4 products or all if less than 4
            let related = [];
            if (filteredProducts.length <= 4) {
                related = filteredProducts;
            } else {
                // Shuffle array and pick first 4
                const shuffled = [...filteredProducts].sort(() => 0.5 - Math.random());
                related = shuffled.slice(0, 4);
            }
            
            setRelatedProducts(related);
            setLoading(false);
            
        } else {
            setLoading(false);
            setRelatedProducts([]);
        }
    }, [all_product, currentProductCategory, props.productId]);

    if (loading) {
        return (
            <div className='relatedproducts'>
                <h1>Related Products</h1>
                <hr />
                <div className="relatedproducts-loading">
                    Loading related products...
                </div>
            </div>
        );
    }

    if (relatedProducts.length === 0) {
        return (
            <div className='relatedproducts'>
                <h1>Related Products</h1>
                <hr />
                <div className="relatedproducts-empty">
                    No related products found in the {currentProductCategory} category.
                </div>
            </div>
        );
    }

    return (
        <div className='relatedproducts'>
            <h1>Related Products</h1>
            <hr />
            <div className="relatedproducts-item">
                {relatedProducts.map((item, i) => (
                    <Item 
                        key={i} 
                        id={item.id} 
                        name={item.name} 
                        image={item.main_image} 
                        new_price={item.new_price} 
                        old_price={item.old_price}
                    />
                ))}
            </div>
        </div>
    );
};

export default RelatedProducts;
